export const FIELD_TYPE = {
  PHONE_NUMBER: '휴대폰번호',
  ACCOUNT_NUMBER: '계좌번호',
  KAKAO_ID: '메신저ID',
  EMAIL: '이메일',
};

export enum FraudPathName {
  fraud = '/fraud',
  report = 'https://cafe-help.joongna.com/form?majorQnaCategory=2&',
}
